import React from "react";
import { NouvelleFenetre } from '../../components/common/NouvelleFenetre';

export const End = ({percentage, quizId, sharingUrl, pdfReportUrl, address}) => {

    const copyText = () => {
        try {
            navigator.clipboard.writeText(sharingUrl);
            alert("Le lien a été copié dans le presse papier");
        } catch (error) {
            alert("Le lien vers le quiz Aux Alentours n'a pas été copiée correctemment", error);
        }
    }

    return (
        <div className="mt-5">
            <div className="container">
                <header data-mh="header-formule-2">
                    <h2 className="heading type3 mt-5">
                        Vous avez <strong className="highlight">{Math.round(percentage)}% </strong>de bonnes réponses 
                    </h2>
                </header>
                <div className="card-version2 -highlight col-10 col-md-6 mx-auto my-5">
                    <div className="primary">
                        <p className="text-center">Partagez votre score sur les réseaux sociaux</p>
                        <ul className="list -unstyled d-flex justify-content-center">
                            <li className="mx-2">
                                <a className="resp-sharing-button__link" href={`https://facebook.com/sharer/sharer.php?u=${sharingUrl}`} target="_blank" rel="noopener noreferrer" aria-label="Partagez sur Facebook (nouvelle fenêtre)" title="Partagez sur Facebook (nouvelle fenêtre)">
                                    <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M41.5083 20.5054C41.5068 9.59625 32.9649 0.597638 22.0706 0.0283799C11.1763 -0.540878 1.74307 7.51849 0.604614 18.3681C-0.533839 29.2177 7.02096 39.0597 17.7962 40.7642V26.4335H12.589V20.5054H17.7962V15.9873C17.7962 10.8475 20.8578 8.00839 25.5422 8.00839C27.0802 8.02979 28.6145 8.16366 30.1328 8.40895V13.4558H27.5468C26.6543 13.3374 25.7563 13.6311 25.1062 14.2541C24.4562 14.8771 24.1245 15.7617 24.2049 16.6585V20.5054H29.8925L28.9833 26.4335H24.2048V40.7642C34.1699 39.1856 41.5075 30.5948 41.5083 20.5054Z" fill="#C62222"/>
                                    </svg>
                                </a>
                            </li>
                            <li className="mx-2">
                                <a className="resp-sharing-button__link" href={`https://twitter.com/intent/tweet/?text=J'ai obtenu ${percentage}&#37; de bonnes réponses au quiz  sur Aux Alentours par MAIF ! Si toi aussi tu veux tester tes connaissances, rendez-vous sur ${sharingUrl}`} target="_blank" rel="noopener noreferrer" aria-label="Partagez sur X (nouvelle fenêtre)" title="Partagez sur X (nouvelle fenêtre)">
                                    <i width="43" height="42" className="maificon maificon-x rounded-circle p-2" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li className="mx-2">
                                <a className="resp-sharing-button__link" href={`https://www.linkedin.com/sharing/share-offsite/?url=${sharingUrl}`} target="_blank" rel="noopener noreferrer" aria-label="Partagez sur LinkedIn (nouvelle fenêtre)" title="Partagez sur LinkedIn (nouvelle fenêtre)">
                                    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M28.6079 28.0983H25.618V23.4205C25.618 22.3049 25.5983 20.869 24.064 20.869C22.5087 20.869 22.2711 22.0857 22.2711 23.3405V28.0983H19.2839V18.4776H22.1504V19.7928H22.1911C22.5901 19.0368 23.5653 18.2388 25.0208 18.2388C28.0474 18.2388 28.6079 20.2311 28.6079 22.822V28.0983ZM15.9121 17.1638C14.9526 17.1638 14.1783 16.3868 14.1783 15.43C14.1783 14.4719 14.9526 13.6949 15.9121 13.6949C16.8702 13.6949 17.6459 14.4719 17.6459 15.43C17.6459 16.3868 16.8702 17.1638 15.9121 17.1638ZM14.4158 28.0983H17.4083V18.4776H14.4158V28.0983ZM30.0976 10.9189H12.9156C12.0953 10.9189 11.4286 11.5699 11.4286 12.3745V29.626C11.4286 30.4279 12.0953 31.0803 12.9156 31.0803H30.0976C30.9192 31.0803 31.5886 30.4279 31.5886 29.626V12.3745C31.5886 11.5699 30.9192 10.9189 30.0976 10.9189ZM21.5083 0C9.90974 0 0.508301 9.40144 0.508301 21C0.508301 32.5986 9.90974 42 21.5083 42C33.1069 42 42.5083 32.5986 42.5083 21C42.5083 9.40144 33.1069 0 21.5083 0Z" fill="#C62222"/>
                                    </svg>
                                </a>
                            </li>
                            <li className="mx-2">
                                <a className="resp-sharing-button__link" href="#" aria-label="Copiez le lien" title="Copiez le lien" onClick={copyText}>
                                    <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2743 24.1403V17.646L24.9837 20.8932L19.2743 24.1403ZM31.9727 15.6025C31.7207 14.6562 30.9805 13.912 30.0407 13.6587C28.3371 13.1993 21.5082 13.1993 21.5082 13.1993C21.5082 13.1993 14.6792 13.1993 12.9756 13.6587C12.0359 13.912 11.2956 14.6562 11.0436 15.6025C10.5882 17.3166 10.5882 20.8932 10.5882 20.8932C10.5882 20.8932 10.5882 24.4697 11.0436 26.1838C11.2956 27.1288 12.0359 27.8743 12.9756 28.1277C14.6792 28.587 21.5082 28.587 21.5082 28.587C21.5082 28.587 28.3371 28.587 30.0407 28.1277C30.9805 27.8743 31.7207 27.1288 31.9727 26.1838C32.4282 24.4697 32.4282 20.8932 32.4282 20.8932C32.4282 20.8932 32.4282 17.3166 31.9727 15.6025ZM21.5083 0C9.90974 0 0.508301 9.40144 0.508301 21C0.508301 32.5986 9.90974 42 21.5083 42C33.1069 42 42.5083 32.5986 42.5083 21C42.5083 9.40144 33.1069 0 21.5083 0Z" fill="#C62222"/>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="text-center">
                    { quizId == 'quiz-items'
                        ?
                            <a href='/quiz-prevention' className="button -primary">Testez le quiz sur les inondations</a>
                        :
                            <a href='/quiz-pedagogique' className="button -primary">Testez le quiz sur les risques climatiques</a>
                    }
                </div>
            </div>
            { quizId == 'quiz-items' ?
                address && address.addressAsQueryParams &&
                    <div className="mod-section mod-conseils bg-2 px-3 py-4 mt-5">
                        <div className="mod-block block-liste-fichier col-12 col-lg-8 border-0 rounded-0 mx-auto pb-4 my-2">
                            <i className="maificon maificon-document text-danger p-2" aria-hidden="true"></i>
                            <div className="heading cnt">
                                <h3>Pour en savoir plus, consultez les documents :</h3>
                            </div>
                            <ul className="list -unstyled">
                                {/* DOC A CREER */}
                                <li className="d-none">
                                    <a href="#" className="link -highlight-icon" target="_blank" rel="noopener">
                                        <span>
                                            Réponses des risques climatiques et technologiques
                                            <span className="fileunit">(PDF - 2 Mo)</span>
                                        </span>
                                        <NouvelleFenetre/>
                                    </a>
                                </li>
                                <li>
                                    <a href={`${pdfReportUrl}/_byAddress${address.addressAsQueryParams}`} className="link -highlight-icon " target="_blank" rel="noopener">
                                        <span>
                                            Kit de prévention à l'adresse
                                            <span className="fileunit">(PDF - 2,7 Mo)</span>
                                        </span>
                                        <NouvelleFenetre/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                :
                <div className="mod-section mod-conseils bg-2 px-3 py-4 mt-5">
                    <div className="mod-block block-liste-fichier col-12 col-lg-8 border-0 rounded-0 mx-auto pb-4 my-2">
                        <i className="maificon maificon-document text-danger p-2" aria-hidden="true"></i>
                        <div className="heading cnt">
                            <h3>Pour en savoir plus, consultez les documents :</h3>
                        </div>
                        <ul className="list -unstyled">
                            <li>
                                <a href="/documents/quiz-aux-alentours.pdf" className="link -highlight-icon" target="_blank" rel="noopener">
                                    <span>
                                        Réponses au questionnaire inondation
                                        <span className="fileunit">(PDF - 2 Mo)</span>
                                    </span>
                                    <NouvelleFenetre/>
                                </a>
                            </li>
                            <li className="d-none">
                                <a href="/documents/jeu-de-cartes-quiz-prevention.pdf" className="link -highlight-icon" target="_blank" rel="noopener">
                                    <span>
                                        Jeu de cartes
                                        <span className="fileunit">(PDF - 737 Ko)</span>
                                    </span>
                                    <NouvelleFenetre/>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.maif.fr/files/live/sites/maif-fr/files/pdf/conseils-prevention/risques-majeurs/inondations/maif-guide-inondations.pdf" className="link -highlight-icon" target="_blank" rel="noopener">
                                    <span>
                                        Guide Inondation
                                        <span className="fileunit">(PDF - 126 Ko)</span>
                                    </span>
                                    <NouvelleFenetre/>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            }
        </div>
    )
}